const EntityType = {
  TEST_SESSION_NOTE: 'TestSessionNote',
  TEST_SESSION_CLIP: 'TestSessionClip',
  TEST_SESSION_ANSWER: 'TestSessionAnswer',
  TEST_SESSION_SPEAKER: 'TestSessionSpeaker',
  REPORT: 'Report',
  TAG_HIGHLIGHT: 'TagHighlight',
};

export default EntityType;
